/*global translate*/
import React, { Component } from 'react'

import * as Jsx from './poll_list_member.jsx'
const RxComponent = global.rootRequire('components/shares/rxComponent').default
const worker = global.rootRequire('classes/globalUser')
// const workerContacts = global.rootRequire('classes/globalContacts')
const chatDB = global.rootRequire('classes/indexedDB').default
class RxPollListMember extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      pollInfo:this.props.pollInfo,
      xPercent:0,
      slickTrackLength:0,
      group: this.props.group,
      answer_selected : this.props.pollInfo.answers[0],
      listMember:{}
    }

    let pollZise = this.props.pollInfo.answers.length
    this.state.slickTrackLength = pollZise * 100 
  }

  componentDidMount(){
    this.fetchListMember()

  }

  chooseAnswer(answer){
    this.setState({answer_selected:answer})
  }

  async fetchListMember(){

    let occupants_uins = this.state.group.occupants_uins
    let listMember = {} 
    for (let i = 0; i < occupants_uins.length; i++) {
      let memberId = occupants_uins[i]
      let userInDB = await chatDB.users.get(Number(memberId))
      if (userInDB) {
        let member = {...userInDB}
        // let contactInDB = await workerContacts.contacts[userInDB.phone] 
        let contactInDB = await chatDB.contacts.get(userInDB.phone)
        member.group_fullname = (userInDB && contactInDB && contactInDB.name) ? contactInDB.name : (userInDB.name_display) ? userInDB.name_display : (userInDB.full_name) ? userInDB.full_name : (userInDB.phone) ? userInDB.phone : ''
        // member.profile_url = userInDB.profile_url || ''
        listMember[memberId]= member
      }
    }
    this.setState({listMember:listMember})
  }

  clickMoveTab(type) {
    let xPercent = this.state.xPercent || 0
    if (type === 'prev') {
      xPercent += 115*3
    } else {
      xPercent -= 115*3
    }
    this.setState({xPercent: xPercent})
  }
  render() {
    return this.renderComponent()
  }
}

export default RxPollListMember
